import {ordersServicesPath} from "../../Constants";
import axios from "axios";

const materialOrganizationOptionRestUrl = ordersServicesPath + '/customers/material-organization-options'
const groupMaterialRestUrl = ordersServicesPath + '/customers/group-materials/get-all-by-organization'

export default class MaterialCustomerOptionService {

    static async getGroup(typeMaterial, subTypeMaterial) {
        const params = {typeMaterial: typeMaterial, subTypeMaterial: subTypeMaterial}

        const queryString = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');

        return axios.get(groupMaterialRestUrl + '?' + queryString);
    }

    static async getAllFilter(group, page, pageSize, sort,
                              typeMaterial, subTypeMaterial, search, archive, supplierId) {
        const groupId = (group && typeof group.id === 'number') ? group.id : null;

        const params = {
            groupMaterialId: groupId,
            page: page,
            pageSize: pageSize,
            sort: sort,
            typeMaterial: typeMaterial,
            subTypeMaterial: subTypeMaterial,
            search: search,
            archive: archive, supplierId: supplierId
        };

        const queryString = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');

        const url = `${materialOrganizationOptionRestUrl}/filter?${queryString}`;

        return axios.get(url);
    }
}


